import { CurrentMatchState } from './interfaces';
import { CurrentMatchStoreStatus } from './enums';

export const initialState: CurrentMatchState = {
  entity: {},
  status: {
    [CurrentMatchStoreStatus.Loading]: [],
    [CurrentMatchStoreStatus.Joining]: [],
    [CurrentMatchStoreStatus.Accepting]: [],
    [CurrentMatchStoreStatus.Declining]: [],
    [CurrentMatchStoreStatus.Withdrawing]: [],
    [CurrentMatchStoreStatus.ViewingAnimation]: [],
    [CurrentMatchStoreStatus.Forfeiting]: [],
  },
};
